module.exports = __webpack_public_path__ + "img/horizontal-bar-icon-21022022.ffe2ed33.svg";